import React, { useEffect } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import { ROUTE_KEYS } from 'utils/constants';
import { Outlet, useLocation } from 'react-router-dom';

const GiftMembersContent = () => {
  const { pathname } = useLocation();
  const { setHideSidebar, setBackLinkTitle, setIsBackLink, setBackLink } = useDashboardContext();

  useEffect(() => {
    setHideSidebar(true);
    setIsBackLink(true);
    if (pathname.includes(ROUTE_KEYS.GIFT_MEMBERS_CONFIRM)) {
      setBackLinkTitle('Back');
      setBackLink(ROUTE_KEYS.GIFT_MEMBERS);
    } else {
      setBackLinkTitle('Return to Dashboard');
      setBackLink(ROUTE_KEYS.DASHBOARD);
    }
    return () => {
      setHideSidebar(false);
      setIsBackLink(false);
      setBackLinkTitle('');
    };
  }, [pathname]);

  return (
    <div className={`min-h-screen flex overflow-x-hidden w-full`}>
      <div className='flex max-lg:flex-col w-full'>
        <div className='w-full body'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default GiftMembersContent;
